var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './TimePicker.module.scss';
import { setHours, getHours, endOfDay, endOfHour, isEqual } from 'date-fns';
import { Dropdown } from '../../../Dropdown/Dropdown';
var TimePicker = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, className = _a.className, id = _a.id, dataId = _a.dataId, onStartChange = _a.onStartChange, onEndChange = _a.onEndChange;
    var onStartHourChange = function (hours) {
        onStartChange(setHours(startDate, parseInt(hours)));
    };
    var onEndHourChange = function (hours) {
        var isDayEnd = parseInt(hours) === 24;
        var date = setHours(endDate, parseInt(hours) - 1);
        onEndChange(isDayEnd ? endOfDay(endDate) : endOfHour(date));
    };
    var formatValue = function (value) { return "".concat(value < 10 ? '0' : '').concat(value, ":00"); };
    var getSelectOption = function (value) { return ({
        value: "".concat(value),
        label: formatValue(value),
    }); };
    var getSelectOptions = function (length, addition) {
        if (addition === void 0) { addition = 0; }
        return Array.from({ length: length }).map(function (c, i) { return getSelectOption(i + addition); });
    };
    var getSelectedStart = function () { return getSelectOption(getHours(startDate)); };
    var getSelectedEnd = function () {
        var isDayEnd = isEqual(endDate, endOfDay(endDate));
        return getSelectOption(isDayEnd ? 24 : getHours(endDate) + 1);
    };
    return (_jsx("section", __assign({ className: "".concat(styles.Timepicker, " ").concat(className ? className : ''), id: id, "data-testid": dataId, onClick: function (e) { return e.stopPropagation(); } }, { children: _jsxs("section", __assign({ className: styles.DropdownsWrapper }, { children: [_jsxs("span", { children: ["Hours of selected day(s) ", _jsx("span", __assign({ className: styles.Dash }, { children: "-" }))] }), _jsx(Dropdown, { small: true, smallText: true, noMargin: true, showSelected: true, dropUp: true, selected: getSelectedStart(), label: 'Start', options: getSelectOptions(24), dataId: 'start-hour', className: styles.Dropdown, onChange: function (h) { return onStartHourChange(h.value); } }), _jsx(Dropdown, { small: true, smallText: true, noMargin: true, showSelected: true, dropUp: true, selected: getSelectedEnd(), label: 'End', options: getSelectOptions(24, 1), dataId: 'end-hour', className: styles.Dropdown, onChange: function (h) { return onEndHourChange(h.value); } })] })) })));
};
TimePicker.propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onStartChange: PropTypes.func.isRequired,
    onEndChange: PropTypes.func.isRequired,
};
export { TimePicker };
//# sourceMappingURL=TimePicker.js.map